export function getIconSize(size: string) {
  if (size === 'sm') {
    return { height: '0.6cm', width: '0.6cm' };
  }
  if (size === 'md') {
    return { height: '0.8cm', width: '0.8cm' };
  }
  return { height: '1.1cm', width: '1.1cm' };
}
